// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__21F91","label":"Section_label__NcDmN","contentWrap":"Section_contentWrap__18y1T","footer":"Section_footer__12sEh","footerInner":"Section_footerInner__3lgaA"};